import React, { Component, useEffect, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import CardMobile from "./cardMobile";
import CardWeb from "./cardWeb";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const CardComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("DigitalCard");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Digital Card",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <CardWeb></CardWeb>
      </BrowserView>
      <MobileView>
        <CardMobile></CardMobile>
      </MobileView>
    </>
  );
};

export default CardComponent;
